<template>
  <v-app
    id="my-widget"
    :style="isWidget ? 'position: fixed; z-index: 9999' : ''"
  >
    <v-main v-if="!isWidget">
      <HeaderCheckout
        v-if="eventDetails && !$route.query.embed && !$route.query.sectorMode"
      />
      <HeaderEmbed v-if="$route.query.embed" />

      <div v-if="!queue && !showPreSale">
        <v-row justify="center" no-gutters>
          <v-row no-gutters class="maxWidthScreen">
            <v-col>
              <router-view
                class="app-container"
                v-if="
                  errorProducts
                    ? false
                    : !$route.query.order_hash
                    ? eventDetails && !loading
                    : orderDetails && !loading
                "
              />
            </v-col>
          </v-row>
        </v-row>

        <div v-if="errorProducts">
          <v-row
            justify="center"
            style="border-bottom: 1px solid #dfdfdf"
            class="py-16"
            no-gutters
          >
            <v-col align="center">
              <span class="accent--text checkout-h3">
                {{ errorProducts }}
              </span>
            </v-col>
          </v-row>

          <div
            v-if="
              errorProducts === 'Vendas encerradas' &&
              filteredPresentations.length
            "
            :class="$vuetify.breakpoint.mdAndUp ? 'px-16' : 'px-6'"
          >
            <v-row class="mt-4" no-gutters>
              <span class="accent--text checkout-h2"> Outras Sessões </span>
            </v-row>

            <MultiplePresentationList
              :filteredPresentations="filteredPresentations"
            />
          </div>
        </div>

        <div v-if="loading" class="loading">
          <half-circle-spinner
            :animation-duration="1000"
            :size="60"
            color="#0067af"
          />
        </div>
      </div>

      <PreSale v-else-if="showPreSale" @getProducts="getProducts" />

      <Queue v-else-if="queue" />

      <whatsapp-balloon v-if="$route.name !== 'Cart' && !$route.query.embed" />
      <SnackBar />
      <ExpirationDialog />

      <input type="hidden" id="idClearSale" :value="hashTerminal" />
    </v-main>

    <!-- WIDGET MODE -->
    <div v-else>
      <card
        :showDialog="showDialog"
        :buttonText="buttonText"
        :buttonPosition="buttonPosition"
        :buttonColor="buttonColor"
        :eventImage="eventImage"
        :verticalPosition="verticalPosition"
        :hideWidget="hideWidget"
        @toogleDialog="showDialog = !showDialog"
      />

      <v-dialog
        v-model="showDialog"
        transition="slide-x-reverse-transition"
        persistent
        hide-overlay
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
        :content-class="
          $vuetify.breakpoint.mdAndUp
            ? buttonPosition === 'left'
              ? 'custom-dialog-left'
              : 'custom-dialog-right'
            : 'custom-dialog-fullscreen'
        "
      >
        <div style="background-color: white">
          <HeaderCheckout
            v-if="
              eventDetails && !$route.query.embed && !$route.query.sectorMode
            "
            :isWidget="isWidget"
            @closeWidget="showDialog = false"
          />
          <HeaderEmbed v-if="$route.query.embed" />

          <div v-if="!queue && !showPreSale">
            <v-row justify="center" no-gutters style="background-color: white">
              <v-row
                no-gutters
                class="maxWidthScreen"
                :class="$vuetify.breakpoint.mdAndUp && isWidget ? 'px-4' : ''"
              >
                <v-col>
                  <div
                    class="app-container"
                    v-if="
                      errorProducts
                        ? false
                        : !$route.query.order_hash
                        ? eventDetails && !loading
                        : orderDetails && !loading
                    "
                  >
                    <Cart v-if="step === 'Cart'" />
                    <Participants v-if="step === 'Participants'" />
                    <Payment v-if="step === 'Payment'" />
                    <finished v-if="step === 'Finished'" />
                  </div>
                </v-col>
              </v-row>
            </v-row>

            <div v-if="errorProducts">
              <v-row
                justify="center"
                style="border-bottom: 1px solid #dfdfdf"
                class="py-16"
                no-gutters
              >
                <v-col align="center">
                  <span class="accent--text checkout-h3">
                    {{ errorProducts }}
                  </span>
                </v-col>
              </v-row>

              <div
                v-if="
                  errorProducts === 'Vendas encerradas' &&
                  filteredPresentations.length
                "
                :class="$vuetify.breakpoint.mdAndUp ? 'px-16' : 'px-6'"
              >
                <v-row class="mt-4" no-gutters>
                  <span class="accent--text checkout-h2"> Outras Sessões </span>
                </v-row>

                <MultiplePresentationList
                  :filteredPresentations="filteredPresentations"
                />
              </div>
            </div>

            <div v-if="loading" class="loading">
              <half-circle-spinner
                :animation-duration="1000"
                :size="60"
                color="#0067af"
              />
            </div>
          </div>

          <PreSale v-else-if="showPreSale" @getProducts="getProducts" />

          <Queue v-else-if="queue" />

          <whatsapp-balloon
            v-if="$route.name !== 'Cart' && !$route.query.embed"
          />
          <SnackBar />
          <ExpirationDialog />

          <input type="hidden" id="idClearSale" :value="hashTerminal" />
        </div>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import { mapGetters } from "vuex";
import Cart from "./views/Cart.vue";
import Participants from "./views/Participants.vue";
import Finished from "./views/Finished.vue";
import Payment from "./views/Payment.vue";
import HeaderCheckout from "./components/shared/HeaderCheckout.vue";
import SnackBar from "./components/shared/SnackBar.vue";
import ExpirationDialog from "./components/shared/ExpirationDialog.vue";
import Queue from "./components/queue/Index.vue";
import HeaderEmbed from "./components/shared/embeded/HeaderEmbed.vue";
import PreSale from "./components/preSale/Index.vue";
import MultiplePresentationList from "./components/cart/multiplePresentations/List.vue";
import WhatsappBalloon from "./components/shared/WhatsappBalloon.vue";
import Card from "./components/widget/Card.vue";
export default {
  name: "App",
  props: [
    "widgetEvent",
    "isWidget",
    "buttonText",
    "buttonColor",
    "buttonPosition",
    "eventImage",
    "verticalPosition",
    "hideWidget",
  ],

  components: {
    HeaderCheckout,
    HalfCircleSpinner,
    SnackBar,
    ExpirationDialog,
    Queue,
    HeaderEmbed,
    PreSale,
    MultiplePresentationList,
    WhatsappBalloon,
    Cart,
    Participants,
    Finished,
    Payment,
    Card,
  },

  data() {
    return {
      alphabet: "abcdefghijklmnopqrstuvwxyz",
      timer: null,
      sendHeightForSite: true,
      cachedHeight: 0,
      showDialog: false,
    };
  },
  async created() {
    setTimeout(() => {
      if (
        !this.$route.name ||
        (this.$route.name === "Cart" &&
          !this.isNumber(this.$route.params.event))
      ) {
        this.$store.commit("SET_EVENT_ID", this.widgetEvent);
        this.$store.commit("SET_WIDGET_MODE", this.isWidget);
        this.startProject(this.widgetEvent);
      }
    }, 1000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    ...mapGetters([
      "loading",
      "eventDetails",
      "productsDetails",
      "orderDetails",
      "errorProducts",
      "couponApplied",
      "queue",
      "storeDetails",
      "showPreSale",
      "screenTimeOn",
      "selectedLanguage",
      "cartProducts",
      "firstPayment",
      "eventId",
      "step",
      "widgetMode",
    ]),
    tiktokPixel() {
      return this.eventDetails?.integracoes_publicas?.find(
        (i) => i.tipo === "tiktok"
      )?.credenciais?.token;
    },

    hashTerminal() {
      let ht = localStorage.getItem("ht");
      return ht;
    },

    filteredPresentations() {
      if (
        this.eventDetails &&
        this.eventDetails.relacionados &&
        this.eventDetails.relacionados.length
      ) {
        let filteredPresentations = this.eventDetails.relacionados.filter(
          (presentation) => {
            let formattedEndDate = this.$moment.unix(
              presentation.data_encerramento_ts
            );

            let today = this.$moment();

            return !formattedEndDate.isBefore(today);
          }
        );

        return filteredPresentations;
      }

      return [];
    },
  },
  watch: {
    async "$route.params.event"(v) {
      if (v) {
        if (this.isNumber(v)) {
          this.$store.commit("SET_EVENT_ID", this.$route.params.event);
          this.startProject(v);
        }
      }
    },
    "$route.query.embed"(v) {
      if (v) this.resetCheckout();
    },
    "$route.query.sectorMode"(v) {
      if (v) this.resetCheckout();
    },
  },
  methods: {
    async startProject(event) {
      const host = window.location.origin;
      await this.$store.dispatch("getStoreDetails", host);

      await this.getHt();
      await this.loginPos();
      this.setStyleStore();
      this.addGtm();
      this.setSelectedLanguage();
      this.riskField();
      await this.$store.dispatch("getEventDetails", event ? event : 29541);
      this.addTikTokPixel();
      this.addFingerPrint();
      this.blueticketAnalytics();
      this.setLoggedUser();
      this.checkIfHaveCoupon();
      this.checkIfShowPreSale();
      if (this.eventDetails?.site_visibilidade !== "Y" || this.$route.query.c)
        await this.getProducts();
      this.checkIfHaveAOrder();
      this.checkIfHaveHashInUrl();
      this.checkIfCartAbandoned();
      this.checkIfHaveCookies();
    },

    resetCheckout() {
      localStorage.removeItem(`sector-selected-${this.eventId}`);
      localStorage.removeItem(`cart-order-route-${this.eventId}`);
      localStorage.removeItem(`isCouponCard-${this.eventId}`);
      localStorage.removeItem(`couponCode-${this.eventId}`);
      this.$store.dispatch("resetPurchase");
      this.timer = setInterval(() => {
        let heightHtml = document.getElementsByTagName("html")[0]?.offsetHeight;
        let heightCart =
          document.getElementsByClassName("container-cart")[0]?.offsetHeight +
          57;

        var msg = {
          height: heightHtml,
        };

        msg.height = heightCart;

        msg.cart = this.cartProducts;

        window.parent.postMessage(msg, "*");
      }, 0);
    },

    async getProducts() {
      await this.$store.dispatch("getProductsAndSectors", {
        event: this.eventId,
        coupon:
          this.$route.query.c || this.couponApplied
            ? this.couponApplied
              ? this.couponApplied
              : this.$route.query.c
            : "",
      });
    },

    checkIfHaveCoupon() {
      if (this.$route.query.c) {
        this.$store.commit("SET_COUPON_APPLIED", this.$route.query.c);
      } else {
        let couponCard = localStorage.getItem(`isCouponCard-${this.eventId}`);
        let coupon = localStorage.getItem(`couponCode-${this.eventId}`);
        if (couponCard) {
          this.$store.commit("SET_COUPON_CARD", coupon);
        }
        if (coupon || couponCard)
          this.$store.commit("SET_COUPON_APPLIED", coupon);
      }
    },

    setLoggedUser() {
      let loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
      this.$store.commit("SET_LOGGED_USER", loggedUser);
    },

    getHt() {
      const uuidv1 = require("uuid/v1");
      let htSetted = null;
      if (this.$route.query && this.$route.query.ht) {
        localStorage.setItem(
          "ht",
          new URL(window.location).searchParams.get("ht")
        );
        htSetted = localStorage.getItem("ht");
      } else {
        htSetted = localStorage.getItem("ht");
      }
      if (htSetted) {
        if (!isNaN(htSetted.charAt(2))) {
          const increment = Number(htSetted.charAt(2)) + 3;
          if (
            (increment >= 10 &&
              String(increment - 10) !== htSetted.charAt(7)) ||
            (increment < 10 && String(increment) !== htSetted.charAt(7))
          )
            htSetted = "";
        } else {
          const indexLetter = this.alphabet.indexOf(htSetted.charAt(2)) + 3;
          if (
            (indexLetter >= 26 &&
              this.alphabet.charAt(indexLetter - 26) !== htSetted.charAt(7)) ||
            (indexLetter < 26 &&
              this.alphabet.charAt(indexLetter) !== htSetted.charAt(7))
          )
            htSetted = "";
        }
      }
      if (!htSetted) {
        let ht = uuidv1();
        ht = ht.substring(0, 7);
        if (!isNaN(ht.charAt(2))) {
          let increment = Number(ht.charAt(2)) + 3;
          if (increment >= 10) ht += increment - 10;
          else ht += increment;
        } else {
          let indexLetter = this.alphabet.indexOf(ht.charAt(2)) + 3;
          if (indexLetter >= 26) {
            indexLetter = indexLetter - 26;
          }
          let increment = this.alphabet.charAt(indexLetter);
          ht += increment;
        }
        htSetted = ht;
      }
      localStorage.setItem("ht", htSetted);
    },

    async loginPos() {
      let username = "checkout@checkout";
      let password = "123456";
      await this.$store.dispatch("login", {
        username: username,
        password: password,
      });
      return;
    },

    blueticketAnalytics() {
      if (
        !this.$route.query.ht &&
        !this.$route.query.embed &&
        !this.$route.query.sectorMode
      ) {
        // window.sendVisit(this.eventId, this.storeDetails.apiUrl);
      }
    },

    async checkIfHaveAOrder() {
      let storage = await JSON.parse(
        localStorage.getItem(`cart-order-route-${this.eventId}`)
      );
      if (storage && !this.$route.query.order_hash && !this.widgetMode) {
        this.$store.commit("SET_LAST_ORDER_AND_CART", {
          cart: JSON.stringify(storage.cart),
          order: JSON.stringify(storage.order),
          route: storage.whereICame,
          selectedSector: JSON.stringify(storage.selectedSector),
        });
        this.$store.dispatch("setProductsDetails", storage.productsDetails);
        this.$store.commit("SET_NOSECTOR_LIST", storage.cart);
        this.$store.commit("SET_ORDER_DETAILS", storage.order);

        if (this.$route.name !== storage.route)
          this.$router.push({
            name: storage.route,
            params: {
              event: this.eventId,
            },
            query: this.$route.query,
          });

        if (storage.selectedSector) {
          let params = {
            event_id: this.eventId,
            sector_id: storage.selectedSector.codigo,
          };
          this.$store.dispatch("getSeatsSector", params);
          this.$store.commit("SET_SELECTED_SECTOR", storage.selectedSector);
          let showMap = localStorage.getItem(`show-map-${this.eventId}`);
          if (showMap) this.$store.commit("SET_SHOW_SEAT_MAP", true);
        }
      } else if (this.$route.query.order_hash) {
        localStorage.removeItem(`cart-order-route-${this.eventId}`);
      }
    },

    setStyleStore() {
      this.$vuetify.theme.themes.light = {
        ...this.$vuetify.theme.themes.light,
        ...this.storeDetails.configs.template.colors,
      };
      if (!this.isWidget) {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = this.storeDetails.configs.template.favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    },

    isLetter(str) {
      return /[a-zA-Z]/.test(str);
    },

    async riskField() {
      let ht = localStorage.getItem("ht");
      var store_domain = "blueticket.com.br";
      var session_id = ht;
      var url =
        ("https:" == document.location.protocol ? "https://" : "http://") +
        "beacon.riskified.com?shop=" +
        store_domain +
        "&sid=" +
        session_id;
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = url;
      var x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    },

    addTikTokPixel() {
      if (this.tiktokPixel) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.innerHTML = `!function (w, d, t) {
          w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
          ttq.load('${this.tiktokPixel}');
          ttq.page();
        }(window, document, 'ttq');`;
        document.getElementsByTagName("head")[0].appendChild(script);
      }
    },

    async addFingerPrint() {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = `(function (a, b, c, d, e, f, g) {
        a['CsdpObject'] = e; a[e] = a[e] || function () {
        (a[e].q = a[e].q || []).push(arguments)
        }, a[e].l = 1 * new Date(); f = b.createElement(c),
        g = b.getElementsByTagName(c)[0]; f.async = 1; f.src = d; g.parentNode.insertBefore(f, g)
        })(window, document, 'script', '//device.clearsale.com.br/p/fp.js', 'csdp');
        csdp('app', 'kg6yn08a4m7i3ju6dvb5');
        csdp('inputsessionid', 'idClearSale');`;
      document.getElementsByTagName("head")[0].appendChild(script);
    },

    addGtm() {
      if (
        this.storeDetails?.configs?.googleTagManager &&
        !this.$route.query.embed &&
        !this.$route.query.sectorMode
      ) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer', '${this.storeDetails?.configs?.googleTagManager}');`;
        document.getElementsByTagName("head")[0].appendChild(script);
      }
    },

    async checkIfHaveHashInUrl() {
      if (this.$route.query.order_hash) {
        await this.$store
          .dispatch("getOrderDetails", this.$route.query.order_hash)
          .then((resp) => {
            if (resp && resp.status === 200) {
              let named = false;
              const { data } = resp;

              const formattedProducts = data.produtos_array.map((p) => {
                return {
                  ...p,
                  quantidade: 0,
                };
              });

              const groupedProducts = this.groupBy(
                formattedProducts,
                "codigo_produto"
              );

              this.$store.commit("SET_NOSECTOR_LIST", groupedProducts);

              data.ingressos.forEach((product) => {
                this.$store.dispatch("addCartProduct", product);
                if (
                  product.dados_extras &&
                  product.dados_extras[0] &&
                  product.dados_extras[0].valor
                )
                  named = true;
              });
              if (
                !(this.$route.name === "Payment" && named) &&
                !(
                  this.$route.name === "Participants" &&
                  !named &&
                  this.firstPayment
                )
              ) {
                this.$router.push({
                  name:
                    named || !this.firstPayment
                      ? "Payment"
                      : this.eventDetails.one_checkout === 40 ||
                        this.eventDetails.one_checkout === 42
                      ? "Payment"
                      : "Participants",
                  params: {
                    event: this.eventId,
                  },
                  query: this.$route.query,
                });
              }
            }
          });
      }
    },

    async checkIfShowPreSale() {
      let storage = await JSON.parse(
        localStorage.getItem(`cart-order-route-${this.eventId}`)
      );
      if (
        this.eventDetails?.site_visibilidade === "Y" &&
        !storage &&
        !this.$route.query.order_hash
      )
        this.$store.commit("SET_SHOW_PRE_SALE", true);
    },

    checkIfCartAbandoned() {
      if (this.$route.query.carrinho_abandonado)
        this.$store.commit("SET_CART_ABANDONED", true);
    },

    setSelectedLanguage() {
      var userLangs = JSON.stringify(navigator.languages);
      let language = "pt";
      if (userLangs.includes("pt")) language = "pt";
      else if (userLangs.includes("es")) language = "es";
      else this.selected = language = "en";
      this.$i18n.locale = language;
      this.$store.commit("SET_SELECTED_LANGUAGE", language);
    },

    checkIfHaveCookies() {
      this.$store.commit("SET_FACEBOOK_COOKIES", {
        fbc: this.$cookies.get("_fbc"),
        fbp: this.$cookies.get("_fbp"),
      });
    },

    isNumber(str) {
      const num = Number(str);
      return !isNaN(num) && typeof num === "number";
    },

    groupBy(collection, property) {
      let i = 0;
      let val;
      let index;
      const values = [];
      const result = [];

      for (i; i < collection.length; i++) {
        val = collection[i][property];
        index = values.indexOf(val);
        if (index > -1) {
          result[index].push(collection[i]);
        } else {
          values.push(val);
          result.push([collection[i]]);
        }
      }
      return result;
    },
  },
};
</script>

<style scoped>
.loading {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
}

#my-widget * {
  font-family: CircularStd;
  font-weight: normal;
  overscroll-behavior: none;
}
</style>

<style>
.app-container {
  height: -webkit-fill-available;
}
.v-text-field--outlined fieldset {
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.v-text-field--filled .v-input__control .v-input__slot,
.v-text-field--full-width .v-input__control .v-input__slot,
.v-text-field--outlined .v-input__control .v-input__slot {
  max-height: 51px !important;
  min-height: 51px !important;
}

.maxWidthScreen {
  max-width: 1240px;
  width: 100%;
}
.v-btn {
  text-transform: none !important;
}
.v-btn .v-btn__content {
  font-weight: normal !important;
  letter-spacing: 0px !important;
}
.checkout-h1 {
  font-size: 28px;
  font-weight: 600;
}

.checkout-h2 {
  font-size: 20px;
  font-weight: 400;
}

.checkout-h3 {
  font-size: 16px;
  font-weight: 500;
}

.checkout-h4 {
  font-size: 14px;
  font-weight: 400;
}

.checkout-h5 {
  font-size: 14px;
  font-weight: 400;
}

.checkout-h6 {
  font-size: 18px;
  font-weight: 400;
}

.checkout-h7 {
  font-size: 11px;
  font-weight: 400;
}

.checkout-h8 {
  font-size: 12px;
  font-weight: 400;
}

.disable-double-tap {
  touch-action: manipulation !important;
}

.custom-dialog-left {
  position: fixed;
  top: 0;
  left: 0;
  max-width: 70vw;
  width: 100%;
  height: 100vh !important;
  max-height: 100% !important;
  margin: 0;
  background-color: white;
}

.custom-dialog-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  max-width: 100vw;
  width: 100%;
  height: 100vh !important;
  max-height: 100% !important;
  margin: 0;
  background-color: white;
}

.custom-dialog-right {
  position: fixed;
  top: 0;
  right: 0;
  max-width: 70vw;
  width: 100%;
  height: 100vh !important;
  max-height: 100% !important;
  margin: 0;
  background-color: white;
}

.v-dialog--active .custom-dialog {
  transform: translateX(0);
}
</style>
